import { render } from "./SliderButton.vue?vue&type=template&id=90da12cc&scoped=true"
import script from "./SliderButton.vue?vue&type=script&lang=js"
export * from "./SliderButton.vue?vue&type=script&lang=js"

import "./SliderButton.vue?vue&type=style&index=0&id=90da12cc&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90da12cc"]])

export default __exports__